// extracted by mini-css-extract-plugin
export default {"accessContainer":"Accessibility_accessContainer__wXXOQ","accessTitle":"Accessibility_accessTitle__Z0PSC","link":"Accessibility_link__G-R7F"};